import Battery from '../lib/battery'

const TTL_IN_SECONDS = 300 // Cache in memory for 5 minutes

let batteryLevel = null
let lastFetch = null
let fetching = false

const init = async () => {
  console.log('Battery Service init')
  return fetch()
}

const fetch = async () => {
  if (!Battery) {
    lastFetch = new Date()
    fetching = false
    batteryLevel = 50
    return
  }
  fetching = true
  const available = await Battery.isAvailableAsync()
  if (!available) {
    lastFetch = new Date()
    fetching = false
    batteryLevel = 0
    return
  }
  batteryLevel = Math.floor(await Battery.getBatteryLevelAsync() * 100)
  lastFetch = new Date()
  fetching = false
}

const ttlExpired = () => {
  if (!lastFetch) {
    return true
  }
  return (new Date().getTime() - lastFetch.getTime()) / 1000 > TTL_IN_SECONDS
}

const maybeRefetch = () => {
  let shouldRefresh = true
  if ((batteryLevel !== null && !ttlExpired()) || fetching) {
    shouldRefresh = false
  }
  if (shouldRefresh) {
    fetch()
      .then(() => {})
      .catch(e => {
        console.log('Error fetching battery level', e.message || e)
      })
  }
}

const get = () => {
  maybeRefetch()
  if (batteryLevel === null) {
    throw new Error('Battery level has not been loaded yet!')
  }
  return batteryLevel
}

export default { init, get }
